import React from 'react';

export const FIELD_NAME_MAP = {
	sewingThread: 'sewingThread',
	mainLabel: 'mainLabel',
	sizeLabel: 'sizeLabel',
	careLabel: 'careLabel',
	shankButton: 'shankButton',
	nippleUpRivet: 'nippleUpRivet',
	snapButton: 'snapButton',
	buckle: 'buckle',
	tapeOrDesignLace: 'tapeDesignLace',
	elastic: 'elastics',
	plasticOrMetalDrawCord: 'drawCord',
	metalHookAndRing: 'metalHookRing',
	stopperOrPuller: 'stopperPullar',
	plasticOrMetalButton: 'button',
	cordOrWireWithMetalStopper: 'cordWireMetalStopper',
	fusing: 'fusing',
	cord: 'cord',
	zipper: 'zipper',
	others: 'others'
};

export const DEFAULT_TRIMS = {
	sewingThread: '',
	mainLabel: '',
	careLabel: '',
	sizeLabel: '',
	zipper: '',
	tapeDesignLace: '',
	button: '',
	shankButton: '',
	snapButton: '',
	metalHookRing: '',
	stopperPullar: '',
	nippleUpRivet: '',
	buckle: '',
	cord: '',
	drawCord: '',
	cordWireMetalStopper: '',
	elastics: '',
	fusing: '',
	others: ''
};

export const calculateFabricCost = (fabrics = []) => {
	if (!fabrics || fabrics.length === 0) {
		return 0;
	}
	return fabrics.reduce((sum, f) => {
		return (
			sum +
			(parseFloat(f.fabricCostWithoutElasticity) || 0) +
			(parseFloat(f.knittingPrice) || 0) +
			(parseFloat(f.fabricDyeingPrice) || 0) +
			(parseFloat(f.heatSetPrice) || 0) +
			(parseFloat(f.peacePrice) || 0) +
			(parseFloat(f.brushPrice) || 0) +
			(parseFloat(f.yarnDyeingPrice) || 0) +
			(parseFloat(f.specialFinishPrice) || 0) +
			(parseFloat(f.elastaneCost) || 0) +
			(parseFloat(f.aopCost) || 0)
		);
	}, 0);
};

export const calculatePrintCost = (prints = []) => {
	if (!prints || prints.length === 0) {
		return 0;
	}
	return prints.reduce((sum, p) => sum + (parseFloat(p.cost) || 0), 0);
};

export const calculateEmbroideryCost = (embroideries = []) => {
	if (!embroideries || embroideries.length === 0) {
		return 0;
	}

	return embroideries.reduce((sum, e) => {
		return sum + (parseFloat(e.cost || e.embroidery_price_usd) || 0);
	}, 0);
};

export const calculateTrimsCost = (trimsData = []) => {
	if (!trimsData) {
		return 0;
	}
	if (Array.isArray(trimsData)) {
		if (trimsData.length === 0) {
			return 0;
		}
		return trimsData.reduce((sum, trim) => {
			return sum + (parseFloat(trim.total_price) || 0);
		}, 0);
	} else {
		return Object.values(trimsData).reduce((sum, val) => sum + (parseFloat(val) || 0), 0);
	}
};

export const calculatePackagingCost = (packagingData = {}) => {
	if (!packagingData || Object.keys(packagingData).length === 0) {
		return 0;
	}

	if (packagingData.cartoonAverageQualityCost !== undefined) {
		return (
			(parseFloat(packagingData.cartoonAverageQualityCost) || 0) +
			(parseFloat(packagingData.polyBagCost) || 0) +
			(parseFloat(packagingData.gumTapTapGunSilicaGelCost) || 0) +
			(parseFloat(packagingData.handTagWithStingsCost) || 0) +
			(parseFloat(packagingData.polyAndCartonStickerCost) || 0) +
			(parseFloat(packagingData.additionalTagsOrPriceTagCost) || 0) +
			(parseFloat(packagingData.sticker) || 0)
		);
	} else {
		return Object.values(packagingData).reduce((sum, val) => sum + (parseFloat(val) || 0), 0);
	}
};

export const calculateWashCost = (washes = []) => {
	if (!washes || washes.length === 0) {
		return 0;
	}
	return washes.reduce((sum, w) => {
		// Support both new format (wash_price_usd) and old format (cost)
		const cost = parseFloat(w.wash_price_usd || w.cost) || 0;
		return sum + cost;
	}, 0);
};

export const formatNumber = (value) => {
	if (value === '' || value === null || value === undefined) return '';
	const num = parseFloat(value);
	return isNaN(num) ? '' : num.toFixed(2);
};

export const getInputValue = (value) => {
	if (value === '' || value === null || value === undefined) return '';
	return value;
};

export const formatNumericValue = (value) => {
	if (value === '' || value === null || value === undefined) return '';
	const num = parseFloat(value);
	return isNaN(num) ? '' : parseFloat(num.toFixed(2));
};

export const parseInputValue = (value, isNumeric = true) => {
	if (value === '' || value === null || value === undefined) return '';
	if (!isNumeric) return value;
	const num = parseFloat(value);
	return isNaN(num) ? '' : num;
};

export const validateRequiredFields = (formData = {}) => {
	const errors = {};
	const currentData = formData || {};

	if (
		currentData?.fabricWisePriceBreakdownList &&
		Array.isArray(currentData.fabricWisePriceBreakdownList)
	) {
		currentData.fabricWisePriceBreakdownList.forEach((fabric, index) => {
			if (!fabric.fabricName || fabric.fabricName.trim() === '') {
				errors[`fabric-${index}-fabricName`] = true;
			}
		});
	}

	if (currentData?.printPriceList && Array.isArray(currentData.printPriceList)) {
		currentData.printPriceList.forEach((print, index) => {
			if (
				print?.selected_print_type ||
				print?.selected_no_of_colors ||
				print?.selected_coverage ||
				print?.selected_area ||
				print?.print_price_usd
			) {
				if (!print.selected_print_type || print.selected_print_type.trim() === '') {
					errors[`print-${index}-type`] = true;
				}
				if (
					!print.selected_no_of_colors ||
					print.selected_no_of_colors === '' ||
					print.selected_no_of_colors === null
				) {
					errors[`print-${index}-numberOfColors`] = true;
				}
				if (
					!print.selected_coverage ||
					print.selected_coverage === '' ||
					print.selected_coverage === null
				) {
					errors[`print-${index}-coverage`] = true;
				}
				if (!print.selected_area || print.selected_area.trim() === '') {
					errors[`print-${index}-areaSize`] = true;
				}
			}
		});
	}

	if (currentData?.embroideryPriceList && Array.isArray(currentData.embroideryPriceList)) {
		currentData.embroideryPriceList.forEach((embroidery, index) => {
			if (
				embroidery?.selected_embroidery_type ||
				embroidery?.selected_coverage_area ||
				embroidery?.embroidery_price_usd
			) {
				if (
					!embroidery.selected_embroidery_type ||
					embroidery.selected_embroidery_type.trim() === ''
				) {
					errors[`embroidery-${index}-type`] = true;
				}
				if (!embroidery.selected_coverage_area || embroidery.selected_coverage_area.trim() === '') {
					errors[`embroidery-${index}-coverage`] = true;
				}
			}
		});
	}

	if (currentData?.washPriceBreakdown && Array.isArray(currentData.washPriceBreakdown)) {
		currentData.washPriceBreakdown.forEach((wash, index) => {
			if (wash?.wash_type || wash?.wash_price_usd) {
				if (!wash.wash_type || wash.wash_type.trim() === '') {
					errors[`wash-${index}-washType`] = true;
				}
			}
		});
	}

	return errors;
};

export const getPartTitle = (partKey) => {
	const partNumber = partKey.replace('part', '');
	const num = parseInt(partNumber);
	if (isNaN(num)) return partKey;

	const suffixes = ['th', 'st', 'nd', 'rd'];
	const v = num % 100;
	const suffix = suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0];
	return `${num}${suffix} Shell`;
};

export const getQuantityWisePrice = (qty, basePrice, baseQty) => {
	const basePrices = [
		{ min: 1, max: 199 },
		{ min: 200, max: 299 },
		{ min: 300, max: 399 },
		{ min: 400, max: 599 },
		{ min: 600, max: 799 },
		{ min: 800, max: 1199 },
		{ min: 1200, max: 1799 },
		{ min: 1800, max: 2799 },
		{ min: 2800, max: 4550 },
		{ min: 4551, max: 8750 },
		{ min: 8751, max: 18050 },
		{ min: 18051, max: 45000 },
		{ min: 45001, max: 100000 }
	];

	const markupSteps = [12, 15, 30, 50, 100];
	const baseRange = basePrices.findIndex((r) => baseQty >= r.min && baseQty <= r.max);
	basePrices.forEach((r, index) => {
		if (baseRange === index) {
			r.markup = 0;
			r.discount = 0;
		} else if (index < baseRange) {
			const distance = baseRange - index - 1;
			r.markup = markupSteps[distance] || 100;
		} else {
			const discountSteps = [0.15, 0.2, 0.25, 0.27, 0.3, 0.35, 0.4];
			const distance = index - baseRange - 1;
			r.discount = discountSteps[distance] || 0.4;
		}
	});

	if (qty === baseQty || parseInt(qty) === 0) return basePrice;

	const applicableRange = basePrices.find((r) => qty >= r.min && qty <= r.max);

	if (!applicableRange)
		return (basePrice - basePrices[basePrices.length - 1].discount)?.toFixed(2) || basePrice;

	// If baseQty is also within the same applicable range, return basePrice
	if (baseQty >= applicableRange.min && baseQty <= applicableRange.max) return basePrice;

	if (applicableRange.markup === 0 || applicableRange.discount === 0) return basePrice;

	if (applicableRange.markup) {
		return (basePrice + (basePrice * applicableRange.markup) / 100).toFixed(2);
	} else if (applicableRange.discount) {
		return (basePrice - applicableRange.discount).toFixed(2);
	}

	return basePrice;
};

export const renderSyncIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 24 24"
			fill="none"
			stroke="#f59e0b"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<polyline points="23 4 23 10 17 10" />
			<polyline points="1 20 1 14 7 14" />
			<path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
		</svg>
	);
};
